import { render } from "./LogoPublic.vue?vue&type=template&id=62cba2ec"
import script from "./LogoPublic.vue?vue&type=script&lang=js"
export * from "./LogoPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__